import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';
import {
  allowsSessionlessWorkflowBuilder,
  isWorkflowBuilderUrl,
  showWorkflowBuilderUi,
} from '../utils/ats-unauthorized-redirect';

export { allowsSessionlessWorkflowBuilder };

/**
 * Protects routes that require a valid ATS session in localStorage
 * (`atsToken` + `atsUserInfo` from `/authorization/:id` handoff).
 * Sends unauthenticated users to access-denied → ATS sign-in.
 * Local `/workflow-builder` can open without a session — see `allowsSessionlessWorkflowBuilder`.
 * Production builds block `/workflow-builder` entirely.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (isWorkflowBuilderUrl(state.url) && !showWorkflowBuilderUi()) {
    void router.navigate(['/ai-agent'], { replaceUrl: true });
    return false;
  }
  if (allowsSessionlessWorkflowBuilder(state.url)) {
    return true;
  }
  const userService = inject(UserService);
  const hasToken = userService.isAuthenticatedMethod();
  const hasUserInfo = userService.getUserInfo() != null;
  if (hasToken && hasUserInfo) {
    return true;
  }
  router.navigate(['/access-denied'], {
    queryParams: { reason: 'session' },
    replaceUrl: true,
  });
  return false;
};
